  /*============Brand Bar Controller
    ================================*/
  angular
    .module('vppApp')
    .controller('brandBarController', brandBarController);

  brandBarController.$inject = ['$scope', '$rootScope', '$timeout', '$state', 'brandBarFactory', '$stateParams', 'vppConfig', 'SetLiveSwapService', 'DealerBrandService'];

  function brandBarController($scope, $rootScope, $timeout, $state, brandBarFactory, $stateParams, vppConfig, SetLiveSwapService, DealerBrandService) {
    //get Live Swap values for image
    var lsValue = SetLiveSwapService.getLSBrandName();
    //get dealer search brand
    var dbrandValue = DealerBrandService.getDBrandName();
    var stateName = $state.current.name;
    var siteCode = vppConfig.folderPath;
    var lsImage;

    if (lsValue) {
      lsImage = vppConfig.lsImage[lsValue];
    } else if(dbrandValue){
      if(dbrandValue === 'CHEVROLET'){
        dbrandValue = 'chevy';
      }
      dbrandValue = dbrandValue.toLowerCase() + 'Tier';
      lsImage = vppConfig.lsImage[dbrandValue];
    } else {
      lsImage = '';
    }

    $rootScope.createAnAccountUserType;
    $scope.$watch(function() {
      return $rootScope.cookie;
    }, function() {
      getbrandBar();

    }, true);

    function getbrandBar() {
      brandBarFactory().then(function(response) {

        $scope.dynamicHeadline = response.data.dynamicHeadline;

        if($scope.dynamicHeadline){

          if($rootScope.createAnAccountUserType && $scope.dynamicHeadline[$rootScope.createAnAccountUserType]){
            $scope.brandBar = response.data.dynamicHeadline[$rootScope.createAnAccountUserType];
          }

        } else {
          $scope.brandBar = response.data;

        }

        $scope.imgRight =  ($scope.brandBar.imgRight) ? $scope.brandBar.imgRight + '.png' : null;
        $scope.imgLeft = ($scope.brandBar.imgLeft) ? $scope.brandBar.imgLeft + '.png' : null;
        $scope.text = $scope.brandBar.text;
        $scope.myClass = $scope.brandBar.text.myClass;
        $scope.iAmClass = $scope.brandBar.iAmClass;
        $scope.iAmImageClass = ($scope.brandBar.iAmImageClass) ? $scope.brandBar.iAmImageClass : null;
        $scope.iAmId = $scope.brandBar.iAmId;
        var liveSwap = $scope.brandBar.liveSwap;
        if ((stateName === 'shopping-tools.find-dealer-results' && dbrandValue) || (lsValue && liveSwap)) {
          if($scope.imgRight){
            $scope.imgRight = $scope.brandBar.imgRight + lsImage + ".png";
            if(dbrandValue === 'cadillacTier' &&
                   (siteCode === 'cgp' ||
                    siteCode === 'mpp' ||
                    siteCode === 'gmed')
            ){
            $scope.imgRight =  undefined;
          }
          } else if ($scope.imgLeft){
            $scope.imgLeft = $scope.brandBar.imgLeft + lsImage + ".png";
          }
        }

      });
    }

    getbrandBar();


  };
